// const server = "http://localhost";
// const port = 9351;
// const domain = "localhost";
const server = "https://testemanuel.mansolutions.app";
const port = 443;
const domain = "web.emanuelimport.com";
const serverImg = 'https://emanuel.nbg1.your-objectstorage.com/public';
export { server, port, domain, serverImg };
